import { Outlet } from "react-router-dom";

const TemplateParentPage = () => {
    return <Outlet />
}
export default TemplateParentPage;